<template>
  <v-card class="player-wait d-flex flex-column ml-1 transparent" depressed flat tile>
    <v-card class="d-flex transparent" depressed flat tile>
      <div v-for="(penalty, i) in player.penalties"
           :key="'penalty_'+i"
           v-show="!penalty.scapegoat"
           class="d-flex align-center mx-0 px-0">

        <v-icon
            v-if="!penalty.finished"
            color="#F73051"
            size="12"
            class="mx-0">
          mdi-clock-time-four
        </v-icon>

        <v-icon
            v-else
            color="#F73051"
            size="12"
            class="mx-0">
          mdi-checkbox-blank-circle-outline
        </v-icon>
      </div>
    </v-card>

    <v-card class="player-time transparent theme-text"
            v-show="showCountdown"
            depressed flat tile
            style="color: #F73051;">
      {{ timeString }}
    </v-card>
  </v-card>
</template>

<script>
import eventBus from '@/eventBus';
import CONSTANTS from "../constants";
import TimeFormatter from "@/TimeFormatter";

export default {
  name: 'PlayerPenalty',
  props: ['player'],
  data: function () {
    return {
      icons: {
        active: 'mdi-clock-time-four',
        finished: 'mdi-checkbox-blank-circle-outline',
        pending: 'mdi-checkbox-blank-circle',
      },
      timeLeft: 0,
      showCountdown: false,
      timeString: "",
      tick: 0
    };
  },
  created() {
    // Feliratkozás az óra eseményeire
    eventBus.$on(CONSTANTS.EVENTS.CLOCK.TICK, this.checkWatch);
    eventBus.$on(CONSTANTS.EVENTS.CLOCK.CHANGED, this.checkWatch);
    eventBus.$on(CONSTANTS.EVENTS.PERIOD.CHANGED.CLOCK, this.checkWatch);

    // JAVÍTÁS: Ha betöltődött az adatbázis, azonnal frissítsünk!
    eventBus.$on(CONSTANTS.EVENTS.CHANGE.GAMEDATALOADED, this.checkWatch);
    // Ha új rekord jött létre (pl. kiállítás hozzáadása), akkor is
    eventBus.$on(CONSTANTS.EVENTS.RECORD.CREATED, this.checkWatch);
  },
  mounted() {
    // JAVÍTÁS: Megjelenéskor azonnal futtatjuk az ellenőrzést (álló óránál is)
    this.checkWatch();
  },
  destroyed() {
    eventBus.$off(CONSTANTS.EVENTS.CLOCK.TICK, this.checkWatch);
    eventBus.$off(CONSTANTS.EVENTS.CLOCK.CHANGED, this.checkWatch);
    eventBus.$off(CONSTANTS.EVENTS.PERIOD.CHANGED.CLOCK, this.checkWatch);
    eventBus.$off(CONSTANTS.EVENTS.CHANGE.GAMEDATALOADED, this.checkWatch);
    eventBus.$off(CONSTANTS.EVENTS.RECORD.CREATED, this.checkWatch);
  },
  watch: {
    // JAVÍTÁS: Figyeljük a játékos büntetéseit!
    // Ha a 'restorePenalties' vagy a 'givePenalty' módosítja a listát, azonnal frissítünk.
    'player.penalties': {
      handler: function() {
        this.$nextTick(() => {
          this.checkWatch();
        });
      },
      deep: true
    }
  },
  methods: {
    // Ez a metódus a template-ben már nem használt, de a kompatibilitás miatt maradhat üresen vagy törölhető
    getPenaltyIcon(penalty) {
      // A sablonban már v-if/v-else kezeli az ikonokat, így erre nincs szükség,
      // de a biztonság kedvéért bent hagyom, hogy ne törjön el semmi.
      return '';
    },

    checkWatch() {
      // Csak Report nézetben (vagy ahol van header logika)
      if (this.$route.meta.header !== "report") return;

      this.tick++;
      const time = window.stopwatch.getTotalTime();

      if (!this.player.penalties || this.player.penalties.length === 0) {
        this.showCountdown = false;
        return;
      }

      // 1. Frissítjük a státuszokat és kiszűrjük a releváns (nem bűnbak) büntetéseket
      let relevantPenalties = this.player.penalties.filter(p => !p.scapegoat);

      relevantPenalties.forEach(p => {
        p.isActive = p.time.start <= time && time < p.time.stop;
        p.finished = p.time.stop <= time;
      });

      // 2. Csak azokat nézzük, amik még nincsenek kész (aktív vagy várakozó)
      let ongoing = relevantPenalties.filter(p => !p.finished);

      if (ongoing.length === 0) {
        this.showCountdown = false;
        this.timeLeft = 0;
        return;
      }

      // 3. Időrendbe rakjuk őket (a legkorábbi elől)
      ongoing.sort((a, b) => a.time.start - b.time.start);

      // 4. LÁNC LOGIKA: Összefűzzük az egymáshoz érő büntetéseket
      // Vesszük a legelsőt (ami épp zajlik, vagy a következő ami indulni fog)
      let currentChainStart = ongoing[0].time.start;
      let currentChainEnd = ongoing[0].time.stop;

      for (let i = 1; i < ongoing.length; i++) {
        let next = ongoing[i];
        // Ha a következő büntetés kezdete "hozzáér" a lánc végéhez (kb. 1 mp tűréssel)
        // Akkor kiterjesztjük a lánc végét a következő végére.
        if (Math.abs(next.time.start - currentChainEnd) < 1.0) {
          currentChainEnd = next.time.stop;
        } else {
          // Ha van szünet a kettő között, akkor a lánc megszakad, a többi már különálló eset
          break;
        }
      }

      // 5. Kiszámoljuk a hátralévő időt a lánc végéig
      // Ha aktív: (lánc vége - mostani idő) -> Pl. 4:00 - 0:10 = 3:50
      // Ha még nem indult el (áll az óra): (lánc vége - mostani idő) -> Pl. 4:00 - 0:00 = 4:00
      this.timeLeft = Math.max(0, currentChainEnd - time);

      this.showCountdown = this.timeLeft > 0;
      this.timeString = TimeFormatter.intToString(this.timeLeft);
    }
  }
}
</script>

<style scoped>
.v-card.player-time {
  font-size: 12px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  text-align: center;
  line-height: 14px;
}
</style>
